import { FC } from 'react'
import { BaseNavbarProps } from '@/components/navbar/Navbar'
import { OptionButton } from '@/components/buttons/option-button/OptionButton'
import { composeClasses } from '../../../utils/compose-classes'
import { MdOutlineClose, MdOutlineMenu } from 'react-icons/md'

export interface ToggleProps {
  title?: BaseNavbarProps['title']
  className?: string
  isOpen?: boolean
  onClick?: () => void
}
export const Toggle: FC<ToggleProps> = ({
  title,
  className,
  isOpen,
  onClick
}) => {
  return (
    <OptionButton
      onClick={onClick}
      className={composeClasses(className, 'whitespace-nowrap')}
    >
      {title && (
        <p className="text-body-bold-m text-primary underline">{title}</p>
      )}
      {isOpen ? (
        <MdOutlineClose className="text-primary min-w-[24px] min-h-[24px] active:scale-90 transition-transform" />
      ) : (
        <MdOutlineMenu className="text-primary min-w-[24px] min-h-[24px] active:scale-90 transition-transform" />
      )}
    </OptionButton>
  )
}
